export default __webpack_public_path__ + "static/media/family-1-stock.764f3503.jpg";